import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class Procedure extends Vue {
   @Prop() id!: string;
   @Prop() casestarttime!: string;
   @Prop() caseendtime!: string;
   @Prop() surgeonname!: string;
  @Prop()  username!: string;
   @Prop() role!: string;
   @Prop() action!: string;
   @Prop() coid!: string;
   @Prop() department!: string
   @Prop() coworkers!: []
  }